<template>
  <div
    class="full-height flex-column"
  >
    <riseup-header>
      <div class="ri-bold-body">
        הרשמה לאתגר
      </div>
    </riseup-header>
    <enter-name v-if="enterNameStep" />
    <enter-email v-else-if="enterEmailStep" />
    <enter-phone-number v-else-if="enterPhoneNumberStep" />
    <signup-enter-code
      v-else-if="enterCodeStep"
      :continue-after-signup="continueAfterSignup"
    />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import { useRoute, useRouter } from 'vue-router';
import _ from 'lodash';
import SignupEnterCode from './steps/SignupEnterCode.vue';
import { useSignupStore } from '../../stores/signup';
import EnterPhoneNumber from './steps/EnterPhoneNumber.vue';
import EnterName from './steps/EnterName.vue';
import EnterEmail from './steps/EnterEmail.vue';
import Segment from '../../Segment';
import MemberAlreadyExists from './MemberAlreadyExists.vue';

const route = useRoute();
const router = useRouter();

const signupStore = useSignupStore();
const { enterCodeStep, enterPhoneNumberStep, enterNameStep, enterEmailStep, memberAlreadyExists } = storeToRefs(signupStore);
Segment.trackUserGot('Signup_Shown');

const continueAfterSignup = () => {
  // Attention! this code is also duplicated in LoginEnterCode.vue
  const redirectTo = route.query.redirectTo as string;
  const queryParams = _.pickBy(route.query, (value, key) => _.startsWith(key, 'utm_'));
  router.push({ path: decodeURIComponent(redirectTo), query: queryParams });
};

</script>

<style lang="scss" scoped>

.full-height {
  height: 100%;
}

</style>
